import { render, staticRenderFns } from "./BannerOne.vue?vue&type=template&id=a05035fe&scoped=true&"
import script from "./BannerOne.vue?vue&type=script&lang=js&"
export * from "./BannerOne.vue?vue&type=script&lang=js&"
import style0 from "./BannerOne.vue?vue&type=style&index=0&id=a05035fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05035fe",
  null
  
)

export default component.exports